
<h5 class="contentHeading">Inspection Details </h5>
<div>
  <div class="contentRow"><p>Site Name</p><p>{{ data[1].Details[0].Value}}</p></div>
  <div class="contentRow"><p>Site Code</p><p>{{ data[1].Details[1].Value}}</p></div>
  <!-- <div class="contentRow" ><p>Site Status</p><p>{{ data[1].Details[2].Value || 'N/A'}}</p></div> -->
  <div class="contentRow"><p>Facility Address</p><p>{{ data[2].Details[0].Value}}</p></div>
  <div class="contentRow"><p>Audit Date</p><p>{{ data[0].Details[2].Value}}</p></div>
  <div class="contentRow"><p>Latitude</p><p>{{ data[2].Details[3].Value}}</p></div>
  <div class="contentRow"><p>Longitude</p><p>{{ data[2].Details[4].Value}}</p></div>
  <div class="contentRow"><p>Tower Type</p><p>{{ data[1].Details[2].Value}}</p></div>
  <div class="contentRow"><p>Tower Height</p><p>{{ data[3].Details[1].Value }}</p></div>
</div>

